import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { setToken, setLoggedIn } from '../reducers/preferenceSlice';
import { useAppDispatch, useAppSelector } from '../reduxHooks';
/**
 * Checa se foi passado o token JWT atravs da URL
 * Caso tenha o token, utiliza esse token e no precisa passar pelo login
 */
function verificaTokenViaURL(today) {
    var _a, _b;
    const searchParams = new URLSearchParams(location.search);
    const tokenURL = searchParams.get('token');
    if (tokenURL) { // seta o localStorage com o token
        const expirationParam = Number(searchParams.get('expiration')) || (today.getTime() + 10 * 60 * 1000);
        const TokenParam = { value: tokenURL, expiration: expirationParam };
        window.localStorage.setItem(`token-${(_b = (_a = window.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_NAME) !== null && _b !== void 0 ? _b : 'comdinheiro'}`, JSON.stringify(TokenParam));
    }
}
export default function useLoggedIn() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const [token, loggedIn] = useAppSelector((state) => [
        state.preference.token,
        state.preference.loggedIn,
    ]);
    const path = location.pathname.substring(1);
    const today = new Date();
    verificaTokenViaURL(today);
    useEffect(() => {
        var _a, _b, _c, _d;
        const storage = window.localStorage.getItem(`token-${(_b = (_a = window.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_NAME) !== null && _b !== void 0 ? _b : 'comdinheiro'}`);
        const { value: sessionToken, expiration: tokenExpiration } = storage
            ? JSON.parse(storage)
            : { value: null, expiration: null };
        if (!token.value && sessionToken && today.getTime() < tokenExpiration) {
            dispatch(setToken({ token: sessionToken, expiration: tokenExpiration }));
            dispatch(setLoggedIn(true));
            return;
        }
        if (token.value && today.getTime() < tokenExpiration) {
            dispatch(setLoggedIn(true));
            return;
        }
        if ((token.value && today.getTime() > tokenExpiration) ||
            tokenExpiration === null ||
            !token.value) {
            if (path !== 'login') {
                navigate(`/login${path !== '' ? `?&redirect=${path}` : ''}${path !== '' && location.search !== '' ? `&${location.search.substring(1)}` : ''}`);
            }
        }
        const emptyToken = { token: '', expiration: null };
        dispatch(setToken(emptyToken));
        window.localStorage.setItem(`token-${(_d = (_c = window.env) === null || _c === void 0 ? void 0 : _c.REACT_APP_NAME) !== null && _d !== void 0 ? _d : 'comdinheiro'}`, JSON.stringify(emptyToken));
    }, [token]);
    // Utilizar os dados mais recentes quando o evento 'popstate' for disparado
    const loggedInRef = useRef(loggedIn);
    const pathRef = useRef(path);
    const locationRef = useRef(location);
    useEffect(() => {
        loggedInRef.current = loggedIn;
    }, [loggedIn]);
    useEffect(() => {
        pathRef.current = path;
    }, [path]);
    useEffect(() => {
        locationRef.current = location;
    }, [location]);
    /**
    * Voltar para a tela de login caso o usuário utilize o botão de voltar do navegador e não estiver logado
    */
    const verificarLoggedIn = () => {
        if (!loggedInRef.current && pathRef.current !== 'login') {
            navigate(`/login${pathRef.current !== '' ? `?&redirect=${pathRef.current}` : ''}${pathRef.current !== '' && locationRef.current.search !== '' ? `&${locationRef.current.search.substring(1)}` : ''}`);
        }
    };
    /**
     * Adiciona eventlistener para verificar login quando voltar/avançar a página no navegador
     */
    useEffect(() => {
        window.addEventListener('popstate', verificarLoggedIn);
        return () => {
            window.removeEventListener('popstate', verificarLoggedIn);
        };
    }, []);
    return loggedIn;
}
